module.exports = __webpack_public_path__ + "atomic/molecule/m-dossier-tile/transport.svg?v=a2f58c";


//////////////////
// WEBPACK FOOTER
// ./Sig.Web/src/atomic/molecule/m-dossier-tile/transport.svg
// module id = 70
// module chunks = 2